import React from "react";

// Badge Component
// export const Badge = ({ text }) => {
//   let textClass = "";

//   if (
//     text === "Project Assigned" ||
//     text === "Project Setup Completed" ||
//     text === "Form Submission In Progress" ||
//     text === "Report Generated" ||
//     text === "Audit Completed" ||
//     text === "Audit Requested" ||
//     text === "In-Process" ||
//     text === "Closed" ||
//     text === "Approved" ||
//     text === "Completed"
//   ) {
//     textClass = "bg-[#46C1BB59]  border border-[#46C1BB]";
//   } else if (
//     text === "Project Setup Pending" ||
//     text === "Audit In Progress" ||
//     text === "Open" ||
//     text === "Sent For Approval" ||
//     text === "Draft"
//   ) {
//     textClass = "bg-blue-200 border border-blue-600";
//   } else if (
//     text === "Form Submitted" ||
//     text === "Report Requested" ||
//     text === "Inactive"
//   ) {
//     textClass = "bg-red-200 text-red-600";
//   } else {
//     textClass = "bg-[#46C1BB59]  border border-[#46C1BB]";
//   }

//   const inputStyle =
//     "text-[11px] font-normal py-2 text-center w-[150px] rounded-md ";

//   return (
//     <div className={`${inputStyle} ${textClass}`} data-value={text}>
//       {text}
//     </div>
//   );
// };

export const Badge = ({ text }) => {
  let textClass = "";

  if (
    text === "Form Submission in Progress" ||
    text === "Rejected" ||
    text === "Audit in Progress" ||
    text === "Form Submission In Progress"
  ) {
    textClass = "bg-[#EAA89D59] text-[#000000] border border-[#EAA89D]";
  } else if (
    text === "Report Generated" ||
    text === "Report Requested" ||
    text === "Not Assigned" ||
    text === "Pending" ||
    text === "Approved" // ✅ Both get yellow now
  ) {
    textClass = "bg-[#E8C45859] text-[#000000] border border-[#E8C458]";
  } else if (text === "Project Setup Completed" || text === "Draft") {
    textClass = "bg-[#6AA4F759] text-[#000000] border border-[#6AA4F7]";
  } else if (text === "Project Setup Pending") {
    textClass = "bg-[#6AA4F759] text-[#000000] border border-[#6AA4F7]";
  } else if (text === "Form Submitted") {
    textClass = "bg-red-200 text-red-600";
  } else if (text === "Forms Submitted" || text === "Completed") {
    textClass = "bg-[#54AEC259] border border-[#54AEC2]";
  } else if (text === "Inactive") {
    textClass = "bg-[#95BFCF] text-[#000000] border border-[#0475A3]";
  } else if (text === "Project Assigned" || text === "In Process") {
    textClass = "bg-[#45827659] text-[#000000] border border-[#458276]";
  } else if (
    text === "Project Created" ||
    text === "Sent for Approval" ||
    text === "Audit in  Progress" ||
    text === "Audit Completed" ||
    text === "Audit Requested" ||
    text === "In-Process" ||
    text === "Closed" ||
    text === "Active"
  ) {
    textClass = "bg-[#45827659] text-[#000000] border border-[#06513D]";
  } else if (text === "Open") {
    textClass = "bg-[#E8C45859] border border-[#E8C458]";
  }

  const inputStyle =
    "text-[11px] font-normal py-1 text-center w-[170px] rounded-md";

  return (
    <div
      className={`${inputStyle} ${textClass}`}
      data-value={text}
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {typeof text === "object" && text !== null ? JSON.stringify(text) : String(text || "")}
    </div>
  );
};
